const debouncer = function debouncer(func, delay) {
    let inDebounce;

    return function debounce() {
        const context = this;
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;

        clearTimeout(inDebounce);

        inDebounce = setTimeout(() => func.apply(context, args), delay);

        return inDebounce;
    };
};

export default debouncer;
